export default {
  loading: false,
  items: []
}